/**
 * Standard throttle function
 * @param fn {function} The function to throttle
 * @param [threshold=250] {Number} Number of milliseconds to throttle
 */
export default function throttle(fn, threshhold = 250) {
  let last
  let deferTimeout

  return function throttleInner() {
    let now = new Date().getTime()
    let args = arguments

    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimeout)
      deferTimeout = setTimeout(function throttleTimeout() {
        last = now
        fn.apply(null, args)
      }, threshhold)
    } else {
      last = now
      fn.apply(null, args)
    }
  }
}
